// extracted by mini-css-extract-plugin
export default {"toolbarPosition":"pricingPriceCalcSchemaTypeGrid_toolbarPosition__8uwMF"};